import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const useFeatures = () => {
  const [features, setFeatures] = useState({ matchmaking_enabled: false, loaded: false });
  useEffect(() => {
    axios.get(`${API}/api/settings/features`)
      .then((r) => setFeatures({ ...r.data, loaded: true }))
      .catch(() => setFeatures((f) => ({ ...f, loaded: true })));
  }, []);
  return features;
};
